import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_taylor-made-plumbing/artifacts/itsf9155_image.png";

export const LogoPlaceholder = ({ variant = "light", testid = "site-logo" }) => {
  const isLight = variant === "light";
  return (
    <div data-testid={testid} className="inline-flex items-center select-none">
      <img
        src={LOGO_URL}
        alt="Taylor Made Plumbing & Services logo"
        className={`h-14 sm:h-16 w-auto object-contain ${
          isLight ? "" : "brightness-0 invert"
        }`}
        loading="eager"
      />
    </div>
  );
};

export default LogoPlaceholder;
